module.exports = __webpack_public_path__ + "img/wenjiang3.fdb595a8.png";